/* eslint-disable react/prop-types */
import React from "react";
import { ThemeContext } from "../../layouts";
import { graphql } from "gatsby";
import Seo from "../../components/Seo";
import Article from "../../components/Article";
import CorePlays from "../../components/CorePlays/CorePlays";

const CorePlaysPage = props => {
  const {
    data: {
      site: {
        siteMetadata: { facebook }
      }
    }
  } = props;
  return (
    <React.Fragment>
      <ThemeContext.Consumer>
        {theme => (
          <Article theme={theme}>
            <CorePlays theme={theme} />
          </Article>
        )}
      </ThemeContext.Consumer>
      <Seo facebook={facebook} />
    </React.Fragment>
  );
};

export default CorePlaysPage;

export const query = graphql`
  query getSiteMetadata {
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
  }
`;
